var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Animate } from "../../Animate";
import { TooltipData } from "./data";
let Tooltip = class Tooltip extends React.Component {
    constructor(props) {
        super(props);
        this.tooltipData = TooltipData.getInstance;
        // tslint:disable-next-line
        this.body = null;
        this.elRef = React.createRef();
    }
    componentDidMount() {
        this.body = document.body;
        this.tooltipData.elRef = this.elRef;
        this.body && this.body.addEventListener("mouseenter", this.tooltipData.show, true);
        this.body && this.body.addEventListener("mouseleave", this.tooltipData.hide, true);
    }
    /* istanbul ignore next */
    componentWillUnmount() {
        this.body && this.body.removeEventListener("mouseenter", this.tooltipData.show, true);
        this.body && this.body.removeEventListener("mouseleave", this.tooltipData.hide, true);
    }
    render() {
        const { isVisible, message, getPosStyles } = this.tooltipData;
        return (React.createElement(Animate, { animation: { scale: isVisible ? 1 : 0 }, duration: 100, interruptBehavior: "finish" },
            React.createElement("div", { className: "rj-tooltip rj-desktop-tooltip", style: getPosStyles, ref: this.elRef }, isVisible && (React.createElement("div", { className: "rj-tooltip__message" }, message)))));
    }
};
Tooltip = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Tooltip);
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map